import { useTranslation } from 'react-i18next';
import SVGIcon from '../../components/atoms/icons';
import Title from '../../components/atoms/title';
import LanguageSelect from '../../components/molecules/language-select';
import Text from '../../components/atoms/text';
import Button from '../../components/atoms/button';
import Input from '../../components/atoms/input';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { NotificationToast } from '../../components/organisms/notification-toast';
import AuthService from '../../services/Auth.service';
import Regex from '../../utils/regex';
import Label from '../../components/atoms/text/label';
import Card from '../../components/atoms/card';
import AuthTemplate from '../../components/template/auth';

interface LoginForm {
	email: string;
	password: string;
	rememberMe: boolean;
}

const RequestPasswordReset = () => {
	const [email, setEmail] = useState<string>('');
	const [error, setError] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);
	const [isTokenGenerated, setIsTokenGenerated] = useState<boolean>(false);

	const navigate = useNavigate();
	const { t } = useTranslation();

	// Exibe erros se existirem
	useEffect(() => {
		if (error) {
			NotificationToast.Warn(t(error));
			setError('');
		}
	}, [error]);

	// Lida com a mudança de input
	const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value);
	};

	// Valida o formulário e envia os dados
	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		// Validações
		if (!email) {
			return setError('alert.error.mandatory');
		}
		if (!Regex.Email(email)) {
			return setError('alert.error.email');
		}
		setLoading(true);

		// Chama o serviço de login
		const response = await AuthService.generateToken(email, setError);

		setLoading(false);

		if (response) {
			setIsTokenGenerated(true);
		}
	};

	const goBack = () => {
		navigate('/login');
	};

	return (
		<AuthTemplate title={t('login.reset_password')}>
			<form
				className="flex flex-col gap-y-6 px-5 py-6 bg-[#ffffff3e] backdrop-blur-50 rounded-xl"
				onSubmit={handleSubmit}
			>
				<SVGIcon
					icon="Arrow2"
					className="w-4 h-auto cursor-pointer stroke-white rotate-90"
					onClick={goBack}
				/>
				{!isTokenGenerated ? (
					<>
						<Text className="text-white" as="h2">
							{t('login.reset_password')}
						</Text>
						<Text className="text-white flex-wrap max-w-96">
							{t('login.reset_password_text')}
						</Text>
						<div className="flex flex-col gap-y-2">
							<Input
								name="email"
								className="w-full"
								placeholder={t('misc.email')}
								type="email"
								value={email}
								onChange={handleInput}
								autoComplete="email"
							/>
						</div>
						<Button type="submit" loading={loading}>
							{t('login.recover_password')}
						</Button>
					</>
				) : (
					<>
						<div className="rounded-full size-20 bg-green flex items-center justify-center self-center">
							<SVGIcon
								className="fill-white h-10 w-auto"
								icon="Check"
							/>
						</div>
						<Text
							className="text-white max-w-96 text-center"
							as="h3"
						>
							{t('login.email_sent')}
						</Text>
						<Text className="text-white text-center">
							{t('login.check_inbox')}
						</Text>
					</>
				)}
			</form>
		</AuthTemplate>
	);
};

export default RequestPasswordReset;
